import { prepareDocForUpdate } from './helpers/firestoreHelpers'

const updateSlide = (slideRef, values) => {
  return slideRef
    .set(prepareDocForUpdate(values), {merge: true})
}

export default updateSlide
